import {
  DeleteOutlined,
  DollarOutlined,
  DownOutlined,
  EditOutlined,
  FileExcelOutlined,
  RightSquareOutlined,
} from "@ant-design/icons";
import { Button, Dropdown, Space } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { replace, useNavigate } from "react-router-dom";
import {
  arqueoCajaSetActive,
  cajaAbiertaSetActive,
  cajaSetActive,
  cajaStartDelete,
  file_download_excel_arqueocaja,
} from "../../../actions/caja";
import { showDeleteConfirm } from "../../../helpers/confirmModal";
import { TableUi, ButtonUi, TagUi, MoreOptionsColumn } from "../../ui";
import {
  EstadoAperturaCajaConstants,
  TipoButtonConstants,
} from "../../../types/typesConstants";
import { open_file } from "../../../helpers/utils";
import { PATH_DIRECTOS } from "../../../helpers";
const key_opts = {
  abrir_caja: "abrircaja",
  arquear_caja: "arquearcaja",
  editar: "editar",
  eliminar: "eliminar",
};

const handleMenuClick = (e, record, acciones) => {
  const {
    handleAbrirCaja,
    handleArquearCaja,
    handleEditar,
    handleEliminar,
    navigate,
  } = acciones;
  switch (e.key) {
    case "abrircaja":
      handleAbrirCaja(record);
      return navigate(PATH_DIRECTOS.puntoventa);
    case "arquearcaja": {
      handleArquearCaja(record);
      return navigate(PATH_DIRECTOS.arqueocaja);
    }
    case "editar":
      handleEditar(record);
      break;
    case "eliminar":
      handleEliminar(record);
      break;
    default:
      break;
  }
};

const itemsCajaAbiertoOptions = () => [
  {
    key: key_opts.abrir_caja,
    label: "Abrir caja",
    icon: <RightSquareOutlined />,
  },
  {
    key: key_opts.arquear_caja,
    label: "Cerrar caja",
    icon: <DollarOutlined />,
  },
  {
    key: key_opts.editar,
    label: "Editar",
    icon: <EditOutlined />,
  },
  {
    key: key_opts.eliminar,
    label: "Eliminar",
    icon: <DeleteOutlined />,
  },
];
// const itemsCajaAbiertoOptions = (data) => {
//   let opts = [];
//   opts = [
//     ...opts,
//     {
//       label: "Imprimir",
//       key: key_opts.print_modal,
//       icon: <PrinterTwoTone twoToneColor="#eb2f96" />,
//     },
//   ];
//   return opts;
// };

const columns = (acciones) => {
  const {
    handleReporteArqueoCaja,
    handleEditarCierreCaja,
    handleMenuItemCajaAbiertoClick,
  } = acciones;
  return [
    {
      title: "N°",
      dataIndex: "nro",
      key: "nro",
      render: (text, record, index) => <>{index + 1}</>,
    },
    {
      title: "Terminal cajero",
      dataIndex: "nombreterminalcajero",
      key: "nombreterminalcajero",
    },
    {
      title: "Local",
      dataIndex: "local_nombre",
      key: "local_nombre",
    },
    {
      title: "Fecha apertura",
      dataIndex: "fechaapertura",
      key: "fechaapertura",
      align: "center",
    },
    {
      title: "Monto Inicial",
      dataIndex: "montoinicial",
      key: "montoinicial",
      align: "right",
    },
    {
      title: "Moneda",
      dataIndex: "nombremoneda",
      key: "nombremoneda",
      align: "center",
    },
    {
      title: "Estado",
      dataIndex: "nombreestadocaja",
      key: "nombreestadocaja",
      align: "center",
      render: (text, record) => (
        <TagUi type={record?.estadocaja} content={text} />
      ),
    },
    {
      title: "Acciones",
      dataIndex: "acciones",
      key: "acciones",
      render: (text, record) => (
        <Space size="middle">
          {record?.estadocaja !== EstadoAperturaCajaConstants.Cerrado && (
            <MoreOptionsColumn
              data={record}
              MenuItems={itemsCajaAbiertoOptions}
              handleMenuItemClick={handleMenuItemCajaAbiertoClick}
            />
          )}
          {record?.estadocaja === EstadoAperturaCajaConstants.Cerrado && (
            <Space wrap>
              <ButtonUi
                typeUi={TipoButtonConstants.EditarTable}
                displayText={false}
                onClick={() => handleEditarCierreCaja(record)}
              />
              <Button
                type="default"
                onClick={() => handleReporteArqueoCaja(record)}
              >
                <FileExcelOutlined style={{ color: "#65B741" }} />
                Reporte arqueo caja
              </Button>
            </Space>
          )}
        </Space>
      ),
    },
  ];
};

export const CajasTable = ({ openDrawer }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { cajas } = useSelector((state) => state.venta);

  const handleAbrirCaja = (data) => {
    localStorage.setItem("caja", JSON.stringify(data));
    dispatch(cajaAbiertaSetActive(data));
    navigate(PATH_DIRECTOS.puntoventa, { replace: true });
  };
  const handleArquearCaja = (data) => {
    localStorage.setItem("caja", JSON.stringify(data));
    dispatch(cajaAbiertaSetActive(data));
    navigate(PATH_DIRECTOS.arqueocaja, { replace: true });
  };

  const handleEditar = (data) => {
    dispatch(cajaSetActive(data));
    openDrawer();
  };
  const handleEliminar = (data) => {
    showDeleteConfirm(
      "¿Está seguro de eliminar la caja seleccionada?",
      data.nombreterminalcajero,
      (isConfirmed) => {
        if (isConfirmed) {
          dispatch(cajaStartDelete(data));
        }
      },
    );
  };
  const handleMenuItemCajaAbiertoClick = (e, field) => {
    switch (e.key) {
      case key_opts.abrir_caja:
        handleAbrirCaja(field);
        break;
      case key_opts.arquear_caja:
        handleArquearCaja(field);
        break;
      case key_opts.editar:
        handleEditar(field);
        break;
      case key_opts.eliminar:
        handleEliminar(field);
        break;
      default:
        break;
    }
  };
  const handleReporteArqueoCaja = async (data) => {
    const file = await file_download_excel_arqueocaja(data?.id);
    const { type: type_file } = file;
    let name_file = "ArqueoCaja-" + data?.arqueocaja?.fechacierre + ".xlsx";
    open_file(file, name_file, type_file);
  };
  const handleEditarCierreCaja = (data) => {
    dispatch(arqueoCajaSetActive(data));
    navigate("/caja/arqueocaja");
  };

  return (
    <TableUi
      columns={columns({
        handleAbrirCaja,
        handleArquearCaja,
        handleEditar,
        handleEliminar,
        navigate,
        handleReporteArqueoCaja,
        handleEditarCierreCaja,
        handleMenuItemCajaAbiertoClick,
      })}
      data={cajas}
      rowKey="id"
      size="small"
    />
  );
};
